/* global axios */
import ApiClient from './ApiClient';

class InternalConversationsAPI extends ApiClient {
  constructor() {
    super('internal_conversations', { accountScoped: true });
  }

  get(inboxId, params = {}) {
    return axios.get(this.url, {
      params: { inbox_id: inboxId, ...params },
    });
  }

  create({ inboxId, recipientId }) {
    return axios.post(this.url, {
      inbox_id: inboxId,
      recipient_id: recipientId,
    });
  }
}

export default new InternalConversationsAPI();
